var m = require('mithril');
var Tabs = require('../components/tabs');
var generalSettings = require('./general');
var unitSettings = require('./units');
var mapModesSettings = require('./mapModes');
var eventsSettings = require('./events');
var notificationsSettings = require('./notifications');
var auditsSettings = require('./audits');
var recycleBinSettings = require('./recycleBin');
const header = require('../layout/components/header');


var settings = {
  oninit: function (vnode) {
    header.vm.activeTab('Settings');
    document.title = 'nimrod | Settings';
  },
  view: function (vnode) {
    var tabs = {
      General: [generalSettings, {}],
      Units: [unitSettings, {}],
      'Map Modes': [mapModesSettings, {}],
      Events: [eventsSettings, {}],
      Reports: [notificationsSettings, {}],
      Audits: [auditsSettings, {}],
      'Recycle Bin': [recycleBinSettings, {}],
    };

    return m('div.mh3.mb5', [
      m('div.v-btm.bb.b--mid-gray.bw1.f-subheadline.mb3.pb2.display.mb3.flex.justify-between.items-center', [
        m('div', [
          m('div.mr2.dib-ns', [
            m('span', 'Settings')
          ])
        ])
      ]),
      m(Tabs, {
        tabs: tabs,
        options: { horizontal: false, default: 'General' },
        route: 'tab',
      })
    ]);
  }
};

module.exports = settings;
